export const EVENT_TYPES = {
  VIEW: 'view',
  PHONE_CLICK: 'click-phone',
  REDIRECT: 'redirect',
};

export const OBJECT_TYPES = {
  ADVERT: 'advert',
  AGENCY: 'agency',
  SPARE_PART: 'sparepart',
};

export const AGGREGATION_FIELDS = {
  USER: 'user',
  OBJECT: 'object',
  FINGERPRINT: 'fingerprint',
};

export const INTERVALS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};



// WEBPACK FOOTER //
// ./src/shared/constants/stats.js